import React, { useState, useEffect, lazy, Suspense } from "react";
import Modal from "../modal";
import titleize from "Utils/titleize";
import trackClick from "Utils/trackClick";
import ShopFocus from "./ShopFocus";
import Badge from "./Badge";
import Promo from "./Promo";
import { clickableAddress, formatUrl, getDesc } from "./helpers";
import promo from "./Promo";

const Shop = (props) => {
  const [modal, setModal] = useState(false);
  const {
    address: { street, city, state, country },
    shop_name,
    phone,
    services,
    specialties,
    website,
    steer_id,
    badges,
    promotions,
  } = props;
  const { url, displayUrl } = formatUrl(website);

  const handleKeyDown = (event) => {
    if (event.keyCode === 27) setModal(false);
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  });

  return (
    <div
      key={street}
      className="bg-white w-full lg:w-halfcolumn rounded lg:flex lg:justify-between shadow"
    >
      {modal && (
        <Modal>
          <ShopFocus
            {...props}
            setModal={setModal}
            url={url}
            displayUrl={displayUrl}
          >
            <div className="flex gap-2">
              <Badge {...badges} country={country} />
              <Promo promos={promotions} />
            </div>
          </ShopFocus>
        </Modal>
      )}
      <div className="p-6 leading-loose text-lg">
        <a
          onClick={() => setModal(true)}
          className="cursor-pointer"
          role="button"
          tabIndex="0"
        >
          <h2
            className="font-sans font-bold text-brand-blue text-xl lg:text-lg hover:text-brand-redhighlight"
            onClick={() =>
              trackClick({
                event_action: "service center name",
                event_label: shop_name,
              })
            }
          >
            {shop_name ? shop_name : null}
          </h2>
        </a>
        {clickableAddress(street, city, state)}
        {phone && (
          <>
            <svg
              className="w-4 inline-block mr-2 text-brand-blue"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <title>Phone Icon</title>
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
            </svg>
            <a
              className="text-brand-textgray font-sans inline-block text-md"
              href={`tel:${phone}`}
              onClick={() =>
                trackClick({
                  event_action: "service center phone",
                  event_label: phone,
                })
              }
            >
              {phone}
            </a>
          </>
        )}
        <br />
        {website && (
          <>
            <svg
              className="w-4 inline-block mr-2 text-brand-blue"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Phone Icon</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
              ></path>
            </svg>
            <a
              className="text-brand-blue underline"
              href={url}
              target="_blank"
              onClick={() =>
                trackClick({
                  event_action: "service center url",
                  event_label: url,
                })
              }
            >
              {displayUrl}
            </a>
          </>
        )}
        {steer_id && (
          <div className="flex mt-2">
            <div>
              <button
                className="bg-brand-red hover:bg-brand-redhighlight text-sm text-white px-4 rounded self-end h-12"
                type="button"
                onClick={() =>
                  AutoOps.show({portalKey: steer_id, ao_affiliate:'TechNet', brandKey:'main_technet_locator'})
                }
              >
                Book Appointment
              </button>
            </div>
          </div>
        )}
        <div className="flex gap-2">
          <Badge {...badges} country={country} />
          <Promo promos={promotions} />
        </div>
      </div>
      {Object.values(services).some((s) => s === true) && (
        <div className="bg-brand-mediumgray lg:w-2/6 rounded-r p-6">
          <h2 className="text-brand-blue font-bold leading-tight text-m">
            Services & Specialties
          </h2>
          <ul className="font-light text-brand-textgray text-sm mt-2">
            {Object.entries(services).map(
              ([service, available]) =>
                available && (
                  <li key={service}>{service ? titleize(service) : null}</li>
                )
            )}
          </ul>
          <ul className="font-light text-brand-textgray text-sm">
            {Object.entries(specialties).map(
              ([service, available]) =>
                available && (
                  <li key={service}>{service ? titleize(service) : null}</li>
                )
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Shop;
